// extracted by mini-css-extract-plugin
module.exports = {"container":"_47f29b8d","imageContainer":"_fbdcbaa","title":"_857df50a","image":"_4de1f92d","viewAll":"_f6fe846","shimmerLoadingBackground":"_33741807"};